import router from '../routes/protectedRoute';
import store from '../vuex/store';

/**
 * Return ellipsis of a given string
 * @param {string} text
 * @param {number} size
 */
const ellipsis = (text, size) => {
  return `${text
    .split(' ')
    .slice(0, size)
    .join(' ')}...`;
};

/**
 * Handle session expired by logging out and redirecting to login page
 * @param {string} redirectPath - Optional path to redirect to after logout (default: '/auth/assessment/login')
 */
const handleSessionExpired = (redirectPath = '/auth-assessment/login') => {
  store.dispatch('logOut');
  router.push(redirectPath);
};

export { ellipsis, handleSessionExpired };
